import Lottie from "react-lottie-player";
import successLottie from "./CallAudit_PageAssignment/ClientSteps/success.json";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";

const IntroThankyou = () => {
    const history = useHistory();

    const handleGoToCallAudit = () => {
        history.push("/agent/call_audited");
    };

    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="d-flex flex-column align-items-center text-center pt-5">
                        <Lottie loop={false} animationData={successLottie} play style={{ width: 300, height: 300 }} />

                        <div className="mt-0 mb-4">
                            <p className="fw-bold mb-3">
                                <span className="fw-bold" style={{ fontSize: "30px" }}>Process Training Completed</span>
                            </p>
                            <p className="fw-semibold mb-4">
                                You've successfully completed the Process Training videos.
                                <br /><br />
                                Next, listen to 90 live calls and mark each criterion as <strong>Pass/Fail</strong> and the overall call as <strong>Good/Bad</strong>.
                            </p>
                            <Button 
                                variant="primary" 
                                onClick={handleGoToCallAudit}
                                style={{ 
                                    backgroundColor: "#17a2b8", 
                                    borderColor: "#17a2b8",
                                    padding: "8px 16px",
                                    fontSize: "16px"
                                }}
                            >
                                Go to Call Training Module
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IntroThankyou;
